import { createAction, props } from '@ngrx/store';
// import { Diagnostic } from 'src/models/module-wise/user/patient';

// TODO: Add Interface

export const paginateDiagnostics = createAction(
  '[ DIAGNOSTIC ] Paginating'
);

export const loadDiagnostics = createAction(
  '[ DIAGNOSTIC ] Load Diagnostic',
  props<{ payload: any[], totalDocuments: number }>()
);

export const editDiagnostic = createAction(
  '[ DIAGNOSTIC ] Edit Diagnostic',
  props<{ payload: any | { status: string, _id: string } }>()
);

export const removeDiagnostics = createAction(
  '[ DIAGNOSTIC ] Delete Diagnostic',
  props<{ payload: string[] }>()
);

export const removeAllDiagnostics = createAction(
  '[ DIAGNOSTIC ] Remove All Diagnostic'
);
